const pageTitlePrefix = ' - Pluva Market';

interface IPageInfo {
  title: string;
  path: string;
}

interface IPluvaMarketPageInfo {
  [key: string]: IPageInfo;
}

export const pageInfo: IPluvaMarketPageInfo = {
  homePage: { title: `홈${pageTitlePrefix}`, path: '/home' },
  infoListPage: { title: `정보${pageTitlePrefix}`, path: '/info/list' },
  infoDetailPage: { title: `정보${pageTitlePrefix}`, path: '/info' },
  productListPage: { title: `매물${pageTitlePrefix}`, path: '/products/list' },
  productDetailPage: { title: `매물${pageTitlePrefix}`, path: '/products' },
  productOptionPage: { title: `매물 옵션${pageTitlePrefix}`, path: '/product-options' },
  openMarketListPage: { title: `오픈마켓${pageTitlePrefix}`, path: '/open-market/list' },
  openMarketDetailPage: { title: `오픈마켓${pageTitlePrefix}`, path: '/open-market' },
  myInfoPage: { title: `마이${pageTitlePrefix}`, path: '/myinfo' },
  myInfoAlarmSettingPage: { title: `알람 설정${pageTitlePrefix}`, path: '/myinfo/alarm-setting' },
  myInfoEditProfilePage: { title: `프로필 수정${pageTitlePrefix}`, path: '/edit-profile' },
  myInfoOwnTractorListPage: { title: `보유 트랙터 관리${pageTitlePrefix}`, path: '/own-tractor-list' },
  myInfoSellTractorListPage: { title: `판매 트랙터 관리${pageTitlePrefix}`, path: '/sell-tractor-list' },
  deleteAccountPage: { title: `회원 탈퇴${pageTitlePrefix}`, path: '/delete-account' },
  loginPage: { title: `로그인${pageTitlePrefix}`, path: '/oauth/login' },
  termsOfUseList: { title: `플루바마켓 이용약관${pageTitlePrefix}`, path: '/terms-of-use/list' },
  downloadAppPage: { title: `플루바마켓 앱 다운로드${pageTitlePrefix}`, path: '/download-app' },
  pluvaAutoPage: { title: `플루바 오토${pageTitlePrefix}`, path: '/pluva-auto' },
  pluvaAutoBusinessPage: { title: `플루바 오토 전시용${pageTitlePrefix}`, path: '/pva' },
  pluvaAutoCustomerServicePage: { title: `플루바 오토 CS${pageTitlePrefix}`, path: '/pva-cs' },

  sellTractorEntryPage: { title: `내 트랙터 판매${pageTitlePrefix}`, path: '/survey/entry/sell-tractor' },
  joinCompletePage: { title: `회원가입 완료${pageTitlePrefix}`, path: '/join-complete' },
};

export const PLUVA_SHOP_URL = 'https://shop.pluva.kr/';
